<template>
  <div class="flies-step">
    <h5 class="pt-1">Receive</h5>
    <div class="py-2">
      <div class="input-group receive-form border-bottom">
        <input
          v-model="key"
          type="text"
          class="form-control"
          placeholder="Enter 6-digital key"
          maxlength="6"
          oninput="value=value.replace(/[^\d]/g,'')"
        />
        <div class="input-group-append">
          <button type="button" class="btn" @click="checkKey()">
            <i class="icon-img icon-xxs img-download"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../../utils/Request";
import { fileLengthFormat } from "../../../utils/Helpers";
import MyLocalStorage from "../../../utils/MyLocalStorage";
import swal from "sweetalert";

export default {
  name: "MyReceive",
  data() {
    return {
      key: "",
      isLoading: false
    };
  },
  model: {
    prop: "transfer"
  },
  props: {
    transfer: Object
  },
  methods: {
    fileLengthFormat(size) {
      return fileLengthFormat(size);
    },
    checkKey() {
      if (!MyLocalStorage.getAccessToken()) {
        $("#login-box").addClass("show");
        return;
      }
      if (this.isLoading || this.key.length === 0) {
        return;
      }
      this.isLoading = true;
      request({
        url: "/v1/transfer/get-info",
        data: {
          transfer_type: 1,
          transfer_key: this.key
        }
      })
        .then(response => {
          if (response.code !== 200) {
            swal(response.msg);
            return;
          }
          $.extend(this.transfer, response.data);
          this.transfer.filesInfo = {
            files: response.data.files,
            total_num: response.data.total_num,
            total_size: response.data.total_size
          };
          if (response.code === 200) {
            this.setWANConnect();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    checkLAN() {
      request({
        baseURL: this.transfer.host_url,
        url: "/check",
        method: "get",
        timeout: 5000,
        withCredentials: false,
        params: {
          keycode: this.key
        }
      })
        .then(() => {
          this.transfer.status = 1;
          this.transfer.is_lan = 1;
          this.transfer.transfer_key = this.key;
          this.transfer.step = 5;
        })
        .catch(() => {
          this.setWANConnect();
        });
    },
    setWANConnect() {
      request({
        url: "/v1/transfer/set-status",
        data: {
          transfer_type: 1,
          id: this.transfer.id,
          status: 1,
          receive_client_name: this.$store.getters.nickname
        }
      }).then(response => {
        if (response.code === 200) {
          this.transfer.step = 5;
          this.transfer.status = 1;
        } else {
          swal(response.msg);
        }
      });
    }
  }
};
</script>
